import { history } from 'ice';
import queryString from 'query-string';

/**
 * 解析url中search字段
 * @returns urlParams 返回search字段中的参数结构体
 */
export const getQueryStringArgs = () => {
  // hash 和 search 的都有，hash 的优先级更高
  const searchQuery = queryString.parse(window.location.search);
  const hashQuery = queryString.parse(window.location.hash.replace(/^[^?]+/, ''));

  return { ...searchQuery, ...hashQuery } as unknown as Record<string, string | null>;
  // return queryString.parse(window.location.hash?.split('?')?.[1]);
};

/**
 * 将参数结构体转换为字符串
 */
export const queryStringify = queryString.stringify;

/**
 * 获取pathname
 */
export const queryPathName = (path?) => {
  if (path) return path?.split('?')?.[0] || '';
  return window.location.hash ? window.location.hash?.split('#')?.[1]?.split('?')?.[0] || '' : window.location.pathname;
};

export default {
  getQueryStringArgs,
  queryStringify,
  queryPathName,
};

/**
 * 带参数跳转
 */
export const historyPush = (path, params) => {
  const _params = Object.assign({}, getQueryStringArgs() || {}, params || {});
  const { lang, spaceId } = _params;
  const { origin, pathname } = window.location;
  window.location.replace(
    `${origin}${pathname}?spaceId=${spaceId || ''}${lang ? `&lang=${lang}` : ''}#${path || '/'}?${queryStringify(_params)}`,
  );
  // history?.push(
  //   `${pathName || '/'}?${queryStringify(Object.assign({}, getQueryStringArgs() || {}, params || {}))}`,
  // );
};
